import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/contact-details', { params }),
  create: params => axios.post('/api/v1/avg/contact-details', params),
  update: params => axios.put(`/api/v1/avg/contact-details/${params.id}`, params),
  remove: params => axios.delete('/api/v1/avg/contact-details', { params })
};
